import React from "react";

// Tier metadata — single source of truth for colours, icons, and labels.
const TIER = {
  public:      { label: "Public",      icon: "🌍", bg: "bg-emerald-100",  text: "text-emerald-800",  ring: "ring-emerald-300",
                 tooltip: "Everyone — including anonymous visitors. Result is on the public homepage." },
  panelists:   { label: "Panelists",   icon: "🧑", bg: "bg-blue-100",     text: "text-blue-800",     ring: "ring-blue-300",
                 tooltip: "Any signed-in panelist (and above). Hidden from anonymous visitors." },
  subscribers: { label: "Subscribers", icon: "💎", bg: "bg-violet-100",   text: "text-violet-800",   ring: "ring-violet-300",
                 tooltip: "Paying customers — subscriber tier and above." },
  enterprise:  { label: "Enterprise",  icon: "💼", bg: "bg-amber-100",    text: "text-amber-900",    ring: "ring-amber-300",
                 tooltip: "Enterprise customers only (top tier). Hidden from subscribers." },
  private:     { label: "Private",     icon: "🔒", bg: "bg-rose-100",     text: "text-rose-800",     ring: "ring-rose-300",
                 tooltip: "Scoped to a single client_id. Visible only in that client's Private Vault." },
};

/**
 * Small, inline visibility pill used across the admin UI, public hub, enterprise hub,
 * and tracker pages so every audience can see (at a glance) WHO sees a given result.
 *
 * Props:
 *   visibility: "public" | "panelists" | "subscribers" | "enterprise" | "private"
 *   clientId:   string (only meaningful when visibility === "private")
 *   size:       "xs" | "sm" (default "xs")
 */
export function VisibilityBadge({ visibility, clientId, size = "xs", className = "" }) {
  const t = TIER[visibility] || TIER.public;
  const padding = size === "sm" ? "px-2 py-0.5 text-xs" : "px-1.5 py-0.5 text-[10px]";
  const label = visibility === "private" && clientId ? `${t.label} · ${clientId}` : t.label;
  return (
    <span
      className={`inline-flex items-center gap-1 font-semibold uppercase tracking-wide ring-1 ${t.bg} ${t.text} ${t.ring} ${padding} ${className}`}
      title={t.tooltip}
      data-testid={`vis-badge-${visibility}`}
    >
      <span aria-hidden="true">{t.icon}</span>
      <span>{label}</span>
    </span>
  );
}

export const TIER_META = TIER;
